import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';
import bg from './bg.json';
import cs from './cs.json';
import da from './da.json';
import el from './el.json';
import et from './et.json';
import fi from './fi.json';
import ga from './ga.json';
import hr from './hr.json';
import hu from './hu.json';
import it from './it.json';
import mt from './mt.json';
import nl from './nl.json';
import pl from './pl.json';
import pt from './pt.json';
import ro from './ro.json';
import sk from './sk.json';
import sl from './sl.json';
import sv from './sv.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      bg: { translation: bg },
      cs: { translation: cs },
      da: { translation: da },
      el: { translation: el },
      et: { translation: et },
      fi: { translation: fi },
      ga: { translation: ga },
      hr: { translation: hr },
      hu: { translation: hu },
      it: { translation: it },
      mt: { translation: mt },
      nl: { translation: nl },
      pl: { translation: pl },
      pt: { translation: pt },
      ro: { translation: ro },
      sk: { translation: sk },
      sl: { translation: sl },
      sv: { translation: sv },
    },

    fallbackLng: 'en',
    supportedLngs: [
      'en',
      'fr',
      'de',
      'es',
      'bg',
      'cs',
      'da',
      'el',
      'et',
      'fi',
      'ga',
      'hr',
      'hu',
      'it',
      'mt',
      'nl',
      'pl',
      'pt',
      'ro',
      'sk',
      'sl',
      'sv',
    ],
    lng: 'en',

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
